import withLandingPageProps from '../../lib/withLandingPageProps';
import LoggedOutLogoMaker from '../LoggedOutLogoMaker';
import './index.scss';

/**
 * @type {React.FC}
 */
export default withLandingPageProps(LoggedOutLogoMaker);
